<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <portal-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Employee Groups' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <portal-employee-groups />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Employees' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <portal-employees />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import PortalGeneral from './PortalGeneral.vue'
import PortalEmployees from './PortalEmployees.vue'
import PortalEmployeeGroups from './PortalEmployeeGroups.vue'

export default {
  components: {
    PortalGeneral,
    PortalEmployees,
    PortalEmployeeGroups
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
